import { Button } from '../../../../components/buttons'
import { colorPalette } from '../../../../style/colorPalette'
import ReloadIcon from '../../../../components/icons/ReloadIcon'
import AddRoundedIcon from '@mui/icons-material/AddRounded'
import { intl } from '../../../../../i18n'

type Props = {
  loading: boolean
  onReload: () => void
  onClickCreateToken: () => void
}

const ApiTokenManagementHeader = ({
  loading,
  onReload,
  onClickCreateToken,
}: Props) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        margin: '10px 10px 5px 10px',
        overflowX: 'auto',
        overflowY: 'hidden',
        minHeight: '47px',
      }}
    >
      <Button
        onClick={onReload}
        disabled={loading}
        sx={{
          background: colorPalette.monotone[1],
          border: `1px solid ${colorPalette.monotone[3]}`,
          borderRadius: '50%',
          height: '28px',
          width: '28px',
          marginRight: '10px',
          padding: '5px 8px',
          cursor: 'pointer',
          '&:hover': { background: colorPalette.monotone[1] },
        }}
      >
        <ReloadIcon />
      </Button>
      <Button
        variant="filled"
        colorPattern="skyBlue"
        size="m"
        onClick={onClickCreateToken}
        disabled={loading}
      >
        <AddRoundedIcon fontSize="small" />
        {intl.formatMessage({
          id: 'apiTokenManagement.createServiceTokenButton',
        })}
      </Button>
      <div style={{ flex: 1 }} />
    </div>
  )
}

export default ApiTokenManagementHeader
